import React from 'react';
import ServiceCard from './ServiceCard';

const Services = ({ data, onNavigate }) => {
    const handleBookConsultation = () => {
        console.log('Here', onNavigate);
        if (onNavigate) {
            onNavigate('contact');
        }
    };

    return (
        <div className="py-20 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <h1 className="text-4xl font-light text-gray-900 mb-4">
                        Therapy Services
                    </h1>
                    <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
                        Comprehensive mental health services tailored to meet your unique needs and support your journey toward wellness.
                    </p>
                    <button
                        onClick={handleBookConsultation}
                        className="bg-stone-800 text-white px-8 py-4 rounded-lg font-medium hover:bg-stone-700 transition-colors duration-200 text-lg"
                    >
                        Book a Consultation
                    </button>
                </div>

                <div className="space-y-12 mb-16">
                    {data.map((service) => (
                        <ServiceCard
                            key={service.id}
                            service={service}
                        />
                    ))}
                </div>

                {/* Additional Service Features */}
                <div className="bg-white rounded-2xl p-8 lg:p-12 shadow-lg">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                        <div>
                            <h3 className="text-2xl sm:text-3xl font-light text-stone-800 mb-6">
                                Flexible Session Options
                            </h3>
                            <div className="space-y-4">
                                <div className="flex items-start space-x-3">
                                    <div className="w-6 h-6 bg-amber-100 rounded-full flex items-center justify-center mt-1">
                                        <div className="w-2 h-2 bg-amber-500 rounded-full"></div>
                                    </div>
                                    <div>
                                        <h4 className="font-medium text-stone-800">In-Person Sessions</h4>
                                        <p className="text-stone-600 text-sm">Face-to-face therapy in a comfortable, private setting</p>
                                    </div>
                                </div>

                                <div className="flex items-start space-x-3">
                                    <div className="w-6 h-6 bg-amber-100 rounded-full flex items-center justify-center mt-1">
                                        <div className="w-2 h-2 bg-amber-500 rounded-full"></div>
                                    </div>
                                    <div>
                                        <h4 className="font-medium text-stone-800">Virtual Therapy</h4>
                                        <p className="text-stone-600 text-sm">Secure online sessions from the comfort of your home</p>
                                    </div>
                                </div>

                                <div className="flex items-start space-x-3">
                                    <div className="w-6 h-6 bg-amber-100 rounded-full flex items-center justify-center mt-1">
                                        <div className="w-2 h-2 bg-amber-500 rounded-full"></div>
                                    </div>
                                    <div>
                                        <h4 className="font-medium text-stone-800">Flexible Scheduling</h4>
                                        <p className="text-stone-600 text-sm">Evening and weekend appointments available</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="bg-stone-50 rounded-xl p-8 text-center">
                            <div className="w-20 h-20 bg-stone-200 rounded-full flex items-center justify-center mx-auto mb-6">
                                <svg className="w-10 h-10 text-stone-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </div>
                            <h4 className="text-xl font-semibold text-stone-800 mb-4">Ready to Begin?</h4>
                            <p className="text-stone-600 mb-6">Schedule a consultation to discuss your needs and goals</p>
                            <button
                                onClick={handleBookConsultation}
                                className="bg-stone-800 text-white px-6 py-3 rounded-lg font-medium hover:bg-stone-700 transition-colors duration-200"
                            >
                                Schedule Your Session
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Services;